import React, { useState } from 'react';
import { LucideIcon } from 'lucide-react';
import './iconTooltip.css';

interface IconTooltipProps {
    icon: LucideIcon;
    showTooltip: boolean;
    label?: string;
    disabled?: boolean;
    position?: 'top' | 'bottom' | 'left' | 'right';
    onClick?: (e?: React.MouseEvent) => void;
    iconSize?: number;
    iconColor?: string;
    disabledColor?: string;
    counter?: number;
    isActive?: boolean;
    isLoading?: boolean;
}

const IconTooltip: React.FC<IconTooltipProps> = ({
    icon: Icon,
    showTooltip = true,
    label,
    disabled,
    position = 'top',
    onClick,
    iconSize = 20,
    iconColor = 'var(--color-grey-dark)',
    disabledColor = 'var(--color-grey-light-text)',
    counter,
    isActive,
    isLoading = false,
}) => {
    const [isHovering, setIsHovering] = useState(false);
    
    return (
        <div 
            className={`hoverLabel-mainContainer ${isActive ? 'hoverLabel-active' : ''}`}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onClick={disabled ? undefined : onClick}
        >
            <div className="hoverLabel-counter">
                {counter}
            </div>
            <Icon
                className={isLoading ? 'iconTooltip-spinning' : ''}
                style={{ color: disabled ? disabledColor : iconColor }}
                size={iconSize}
            />
            {isHovering && showTooltip && (
                <div className={`hoverLabel-tooltip hoverLabel-tooltip--${position}`}>
                    {label}
                </div>
            )}
        </div>
    );
};

export default IconTooltip;